import React, { useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { useHistory } from "react-router-dom";

const Login = () => {
    const { authState, oktaAuth } = useOktaAuth();
    const history = useHistory();

    useEffect(() => {
        if (!authState.isPending && !authState.isAuthenticated) {
            const fromUri = history.createHref(history.location);
            oktaAuth.signInWithRedirect(fromUri);
        }
    }, [authState, oktaAuth, history]);

    return <div></div>;
};

export default Login;
